/**
 * The trainer's group page, below what to do now: four tabs (06.10.2026).
 * The documents are named the way people say them, the annex number under.
 */
export const TABS = [
  { key: "cursanti", label: "Cursanți" },
  { key: "prezenta", label: "Prezență" },
  { key: "portofolii", label: "Portofolii" },
  { key: "documente", label: "Documente" },
];

/** A Curs FPED cohort (13.10.2026): its participants and its simple attendance. */
export const FPED_TABS = [
  { key: "cursanti", label: "Cursanți" },
  { key: "prezenta", label: "Prezență" },
];

export function tabOf(value, tabs = TABS) {
  return tabs.some((t) => t.key === value) ? value : tabs[0].key;
}

/** The group's documents, in the order the course makes them. The individual
 * score sheets (Anexele 8 și 11) are each evaluator's own and are not listed. */
export const DOCS = [
  { kind: "annex_4_2", name: "Prezența pe zile", annex: "Anexa 4.2", where: "fila Prezență", perDay: true },
  { kind: "annex_4_3", name: "Orele asincrone", annex: "Anexa 4.3", where: "fila Prezență" },
  { kind: "annex_5", name: "Catalogul de prezență", annex: "Anexa 5", where: "fila Prezență" },
  { kind: "annex_6", name: "Verificarea portofoliilor", annex: "Anexa 6", where: "fila Portofolii" },
  { kind: "annex_7", name: "Decizia comisiei", annex: "Anexa 7", where: null },
  { kind: "annex_9", name: "Rezultatele portofoliilor", annex: "Anexa 9", where: null },
  { kind: "annex_10", name: "Prezența la susținere", annex: "Anexa 10.2", where: null },
  { kind: "annex_12", name: "Rezultatele finale", annex: "Anexa 12", where: null },
  { kind: "annex_13", name: "Procesul-verbal", annex: "Anexa 13", where: null },
];

/** The latest version of each document (one per day for Anexa 4.2), with how
 *  many came before it, in DOCS order. */
export function latestDocs(documents) {
  const out = [];
  for (const def of DOCS) {
    const rows = (documents || []).filter((d) => d.kind === def.kind);
    const scopes = [...new Set(rows.map((d) => d.scope || ""))].sort();
    if (scopes.length === 0) {
      out.push({ def, doc: null, older: 0 });
      continue;
    }
    for (const scope of scopes) {
      const same = rows.filter((d) => (d.scope || "") === scope).sort((a, b) => b.version - a.version);
      out.push({ def, doc: same[0], older: same.length - 1 });
    }
  }
  return out;
}

/** The asynchronous hours of one participant, as the Cursanți tab shows them.
 * While the course runs nobody is "under the threshold" yet: the bar shows
 * how far they are; the verdict comes once the last session is over. */
export function hoursLook(row, { over, denominator }) {
  const done = row?.done_hours || 0;
  const of = denominator || 0;
  const share = of ? Math.min(1, done / of) : 0;
  if (!over) return { share, tone: "neutral", bar: "bg-[#965EA7]", label: "" };
  if (row?.below) return { share, tone: "late", bar: "bg-[#c0483f]", label: "sub prag" };
  return { share, tone: "good", bar: "bg-[#519872]", label: "" };
}

/** "3 din 5" handed in, and what waits on either side. */
export function homeworkLine(cells, activityIds) {
  const states = activityIds.map((id) => cells?.[id]?.state || "not_started");
  const handed = states.filter((s) => ["waiting", "submitted", "needs_work", "accepted"].includes(s)).length;
  return {
    handed, total: activityIds.length,
    waiting: states.filter((s) => s === "waiting").length,
    redo: states.filter((s) => s === "needs_work").length,
    missing: states.filter((s) => s === "missing").length,
    lateFeedback: activityIds.some((id) => cells?.[id]?.late_feedback),
  };
}
